
<div class="card" style="margin-bottom:20px">
    <div class="p-grid">
        <div class="p-col-12 p-md-12 p-lg-4">
            <h5 class="cF1">Message preview</h5>
            <div class="pMsg"><b>{{pmsg}}</b> <br/><br/>
                Welcome to [company name]! We are happy that you have contacted us. We use WhatsApp to communicate closely with you! If you have any question, we will be glad to help you.    
                <br/><br/><b>{{msg}}</b></div>
        </div>
        <div class="p-col-12 p-md-12 p-lg-8">
            <h5 class="cF1">Position</h5>
            
            <p-selectButton [options]="justifyOptions" [(ngModel)]="value" optionLabel="icon" optionValue="value">
                <ng-template let-item>
                    <i [class]="item.icon"></i>
                </ng-template>
            </p-selectButton><br/>
            <h5 class="cF1">Usage configuration</h5>
            <p-selectButton [options]="usageOptions" [(ngModel)]="value1" optionLabel="name" optionValue="value"></p-selectButton><br/>
            <h5 class="cF1">Enter your signature</h5>
            <p *ngIf="value==='1'" class="cF2">Prepend: signature be added at begning of the message</p>
            <p *ngIf="value==='3'" class="cF2">Prepend: signature be added at begning of the message</p>
            <textarea *ngIf="value==='3'"  class="cTA1" [rows]="3" [cols]="30" [(ngModel)]="pmsg" pInputTextarea [autoResize]="true"></textarea>
            <textarea *ngIf="value==='1'" class="cTA1" [rows]="3" [cols]="30" [(ngModel)]="pmsg" pInputTextarea [autoResize]="true"></textarea>
            <p *ngIf="value==='2'" class="cF2">Append: signature be added at end of the message</p>
            <p *ngIf="value==='3'" class="cF2">Append: signature be added at end of the message</p>
            <textarea *ngIf="value==='2'" class="cTA1" [rows]="3" [cols]="30"  [(ngModel)]="msg" pInputTextarea [autoResize]="true"></textarea>
            <textarea *ngIf="value==='3'" class="cTA1" [rows]="3" [cols]="30"  [(ngModel)]="msg" pInputTextarea [autoResize]="true"></textarea>
            <h5 class="cF1"></h5>
        </div>
    </div>
    <div>
        <div class="row">
            <button pButton pRipple type="button" label="Create signature" class="p-button-raised fR"></button>
        </div>
    </div>   
</div>
